
import { defineComponent, provide, ref } from "vue";
import { session_key, collapse_key } from "@/symbols";

export default defineComponent({
  setup() {
    provide(collapse_key, ref<boolean>(false));
    provide(session_key, ref<boolean>(false));
  },
});
